import { render } from "./PopularPlaces.vue?vue&type=template&id=0cb2bf16&scoped=true"
import script from "./PopularPlaces.vue?vue&type=script&lang=js"
export * from "./PopularPlaces.vue?vue&type=script&lang=js"

import "./PopularPlaces.vue?vue&type=style&index=0&id=0cb2bf16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb2bf16"]])

export default __exports__